<template>
  <div class="map">
    <div class='address'>
      <div class="address-box">
        <p><span class="icon-location"></span>自提地点</p>
        <h3 v-if="mapAddr!=null && mapAddr!='' && mapAddr!=undefined">{{mapAddr}}</h3>
      </div>
      <img class="pic" :src="mapPic" v-if="mapPic!=null && mapPic!='' && mapPic!=undefined">
      <div class="no-pic" v-else></div>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        mapAddr: window.localStorage.getItem('mapAddr'),
        mapPic: window.localStorage.getItem('mapPic')
      }
    },
    // created () {
    //   document.title = "查看地图"
    // },
    methods: {

    }
  }
</script>



// WEBPACK FOOTER //
// Map.vue?049bcc92